/**
 * Detect mobile / touch-first devices for live-training UX routing.
 */
export function isMobileDevice() {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 768px)").matches;
  const coarse = window.matchMedia("(pointer: coarse)").matches;
  const ua = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ""
  );
  return narrow || coarse || ua;
}

export default isMobileDevice;
